interface ImagePreviewProps {
  sourceImage?: string | null;
  backgroundImage?: string;
  className?: string;
  alt?: string;
}

const ImagePreview = ({ 
  sourceImage, 
  backgroundImage = "url('/images/preview.png')", 
  className = "",
  alt = ""
}: ImagePreviewProps) => {
  return (
    <div className={`overflow-hidden lg:h-full aspect-square lg:aspect-auto max-h-[375px] ${className}`}>
      <div className="p-6 bg-white w-full h-full rounded-xl border border-gray-200">
        <div 
          className="w-full h-full overflow-hidden rounded-xl bg-repeat relative" 
          style={{ backgroundImage }}
        >
          {sourceImage && (
            <img 
              src={sourceImage} 
              alt={alt} 
              className="object-contain w-full h-full aspect-square" 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
